import { useEffect, useState } from 'react';
import ArrowIcon from '../assets/arrow.svg';
import AddCart from '../assets/addcart.svg';
import Cart from '../assets/cart.svg';
import Close from '../assets/close.svg';
import Minus from '../assets/minus.svg';
import { useAppContext } from '../context/Context';
import { getcustnum } from './queries';
import Checkout from './Checkout';
import { Elements } from '@stripe/react-stripe-js';
import { checkInventory } from './queries';
import Stripe from '../assets/stripe.svg';
import c from '../assets/config';
import { useLocation } from 'react-router-dom';

function Wbw() {

    // context provided
    const { handleOptions, stripePromise, options, inventory } = useAppContext();

    function resetCart() {
        setCart([0,0,0,0,0,0,0,0])
        setSize(0.0)
    }

    //referal checkout
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    useEffect(() => {
        const products = queryParams.get('products');
        let productDetails = [];
        let newCart = [0,0,0,0,0,0,0,0];
        let newSize = 0;
        
        if (products) {
            productDetails = products.split(',').map( item => {
                const [id, quantity] = item.split(':');
                return { id, quantity: parseInt(quantity) };
            });
            productDetails.forEach(element => {
                newSize += element.quantity;
                switch (element.id) {
                    case 'gatq0jrijr':
                        //navy
                        newCart[0] = element.quantity;
                        break;
                    case '4pf2l0051q':
                        //gray
                        newCart[1] = element.quantity;
                        break;
                    case 'ia3tvleo2b':
                        //burgundy
                        newCart[2] = element.quantity;
                        break;
                    case 'aubzi3jbva':
                        //orange
                        newCart[3] = element.quantity;
                        break;
                    case 'nky5tcqnyo':
                        //brown
                        newCart[4] = element.quantity;
                        break;
                    case 'puhe97z49k':
                        //yellow
                        newCart[5] = element.quantity;
                        break;
                    case '9w3vwy6qyz':
                        //green
                        newCart[6] = element.quantity;
                        break;
                    case '0gkqtp3ads':
                        //light blue
                        newCart[7] = element.quantity;
                        break;
                    default:
                        break;
            }
            setCart(newCart);
            handleSize(newSize);
            setWindow(true);
        });
        
        }
    },[])

    //set the currently selected color
    const [currentColor, setCurrentColor] = useState(0)
    function handleColor(color){
        setCurrentColor(color)
    }
    //const colorpic = ['blue.png','gray.png','burgundy.png','orange.png','brown.png','yellow.png','green.png','lightblue.png']
    //const dotcolors = ['darkblue','gray', 'darkred', 'orange', 'rgb(180,155,47)', 'yellow', 'green', 'lightblue']

    //set description pictures
    const [currentPic, setCurrentPic] = useState(0)
    function handlePic(){
        if (currentPic == c.products[0].descpic.length-1){
            setCurrentPic(0)
        }else{
            setCurrentPic(currentPic+1)
        }
    }
    //const descpic = [c.colorpic[currentColor],'5.png','14.png']

    //set shopping cart
    const [currentCart, setCart] = useState([0,0,0,0,0,0,0,0])
    const [cartSize, setSize] = useState(0.0)
    const [checkoutWindow, setWindow] = useState(false)
    async function handleCart(item, cart, total){
        cart[item] = await (cart[item]+1);
        setCart(cart);
        handleSize(total+1)
    }
    async function minusCart(item, cart, total){
        cart[item] = (cart[item]-1);
        setCart(cart);
        handleSize(total-1);
        if((total-1) == 0) {
            setWindow(false)
        }
    }
    function handleSize(size){
        setSize(size)
    }

    //set payment
    const [paymentWindow, setPayment] = useState(false)
    function closeWindows(){
        setWindow(false)
        setPayment(false)
    }
    async function setupPayment(num){
        const custinfo = await getcustnum(num)
        if (!custinfo){
            setPayment(false)
            checkInventory()
            resetCart()
        }else{
            await handleOptions(custinfo)

            setPayment(true)
        }
    }

        //close out
    async function resetOrder(){
        try{
            await checkInventory()
        }catch{
            pass
        }
        
        setCart([0,0,0,0,0,0,0,0])
        setSize(0.0)
        setWindow(false)
        handleOptions(null)
        handleColor(0)
        setCurrentPic(0)
        setPayment(false)
    }

  return (
    checkoutWindow == true?
        paymentWindow == true?
            <Elements stripe={stripePromise} options={options}>
                <div className='cart'>
                    <img style={{padding:'3px'}} className='pics' onClick={()=>closeWindows()} src={Close} />
                </div>
                <Checkout setPayment={setPayment} currentCart={currentCart} cartSize={cartSize} resetOrder={resetOrder}/>
            </Elements>
        :
            <div className='page' style={{background:'white'}}>
                <div className='box cart' style={{top:'0px'}}>
                    <img style={{padding:'3px'}} className='pics' onClick={()=>closeWindows()} src={Close} />
                </div>
                <div className='checkoutList'>
                    {
                        currentCart.map((item, index) => {
                            return (
                                <div key={index} className='checkoutItem'>
                                    <div className='colorcircle' style={{backgroundColor:c.products[0].dotcolors[index], textAlign:'center', fontSize:11, display:'flex',alignItems:'center'}}>{inventory[index] == 0 ?"sold out":''}</div>
                                    { inventory[index] == 0 || currentCart[index] >= inventory[index]?
                                        <div style={{height:'30px', width:'30px', padding:'3px', margin:'10px'}} />
                                    :    
                                        <img style={{padding:'3px', margin:'10px', rotate:'45deg'}} className='pics' onClick={()=>handleCart(index, currentCart, cartSize)} src={Close} />
                                    }
                                    <div className='text'>
                                        {item}
                                    </div>
                                    {item > 0 ?
                                        <img style={{padding:'3px', margin:'10px',}} className='pics' onClick={()=>minusCart(index,currentCart, cartSize)} src={Minus} />
                                        :<div style={{height:'30px', width:'30px', padding:'3px', margin:'10px'}} />
                                    }
                                </div>
                            )
                        })
                    }
                </div>
                <div className='stack box'>
                    <div onClick={()=>setupPayment(currentCart)} className='text normalbutton box'>
                        Checkout ${cartSize*11.00} <img style={{height:'23px', padding:'3px'}} src={Stripe} />
                    </div>
                </div>
            </div>
    :
      <div className='page' style={{background:'white'}}>
        <div className='box cart'>
            {cartSize > 0 ?
            <>
                <div className='bubble'>
                    {cartSize}
                </div>
                <img style={{padding:'3px'}} onClick={()=>setWindow(true)} className='pics' src={Cart} />
            </>
            :''}
        </div>
        <div className='box circles'>
            {
                inventory.map((item, index) => {
                    return <div className='colorcircle' onClick={()=>handleColor(index)} style={{backgroundColor:c.products[0].dotcolors[index],  textAlign:'center', fontSize:11, display:'flex',alignItems:'center'}}>{inventory[index] > 0 ?"":'sold out'}</div>
                })
            }
        </div>
        <div className='picViewer'>
            <img style={{width:'auto', height:'100%'}} src={currentPic==0?c.products[0].colorpic[currentColor]:c.products[0].descpic[currentPic]} />
        </div>
        <div className='box arrows'>
            <div className='box arrow'>
                <img className='pics' onClick={() => handlePic(currentPic)} src={ArrowIcon} />
            </div>
            <div className='box arrow'>
                { inventory[currentColor] == 0 || currentCart[currentColor] >= inventory[currentColor]?
                    <img className='deadpic' style={{padding:'3px', opacity:'40%'}} src={AddCart} />
                :
                    <img className='pics' style={{padding:'3px'}} onClick={() => handleCart(currentColor,currentCart,cartSize)} src={AddCart} />
                }
            </div>
            <div className='text box arrow'>
                ${c.products[0].price}
            </div>
            <div className='box arrow' style={{rotate:'180deg'}}>
                <img className='pics' onClick={() => handlePic(currentPic)} src={ArrowIcon} />
            </div>
        </div>
      </div>
  );
}

export default Wbw;